import { Lens } from 'monocle-ts';

import { rootDomain } from '@stores/root';

import { applyLensPayload } from '@utils/lens';

import { ButtonVariant } from '@components/common/Button/Button';

export type ConfirmDialogDescriptionColor = 'black' | 'gray';
export type ConfirmDialogDescriptionMarginTop = 8 | 32;
export type ConfirmDialogDescription = null | {
    text: string;
    color: ConfirmDialogDescriptionColor;
    marginTop: ConfirmDialogDescriptionMarginTop;
};

export type ConfirmDialogState = {
    isOpen: boolean;
    options: {
        title: string;
        description: ConfirmDialogDescription;
        applyButton: {
            text: string;
            variant: ButtonVariant;
            onClick(): void;
        };
        disagreeButtonText: string;
        isLoading?: boolean;
    };
};
const confirmDialogDomain = rootDomain.createDomain();

// --- Events ---
export const resetConfirmDialog = confirmDialogDomain.createEvent();
export const setConfirmDialog = confirmDialogDomain.createEvent<ConfirmDialogState>();
export const setConfirmDialogLoading = confirmDialogDomain.createEvent<boolean>();

// --- Lens ---
export const confirmDialogLoadingLens = Lens.fromPath<ConfirmDialogState>()([
    'options',
    'isLoading',
]);

const confirmDialogInitialState: ConfirmDialogState = {
    isOpen: false,
    options: {
        title: 'Заголовок',
        description: null,
        applyButton: {
            text: 'Принять',
            variant: 'whiteRed',
            onClick: () => resetConfirmDialog,
        },
        disagreeButtonText: 'Отменить',
        isLoading: true,
    },
};

/**
 @example
 setConfirmDialog({
     isOpen: true,
     options: {
         title: 'Вы точно хотите удалить адрес?',
         description: {
             text: 'Находка, ул. Харьковская, 8, п.2, кв 54?',
             color: 'black',
             marginTop: 32,
         },
         applyButton: {
             text: 'Удалить',
             variant: 'whiteRed',
             onClick: () => setIsOpenConfirmDialog(false),
         },
         disagreeButtonText: 'Отмена',
     },
 });
 */

export const $confirmDialog = confirmDialogDomain
    .createStore<ConfirmDialogState>(confirmDialogInitialState, { name: 'confirm-dialogs' })
    .on(setConfirmDialog, (_, payload) => payload)
    .on(setConfirmDialogLoading, applyLensPayload(confirmDialogLoadingLens))
    .reset(resetConfirmDialog);
